export default __webpack_public_path__ + "static/media/right.014e12fc.png";